import { Component, Input } from '@angular/core';

@Component({
  selector: 'dcc-page-title',
  template: '{{ title }}',
  styles: [':host { margin-bottom: 20px;}'],
  host: { class: 'lx-section-title' },
})
export class PageTitleComponent {
  @Input() title: string;
}
